import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

class ModalManageContentInfoRowDiffData extends Component {
    translateChangedItem(changeName) {
        const arrayAfterUpperFirst = changeName.map(singleWord => {
            return _.upperFirst(singleWord.toString().replace(/([a-z])([A-Z])/g, '$1 $2'));
        });

        return arrayAfterUpperFirst.join(' > ');
    }

    translateKindSymbolToText(kindSymbol) {
        switch (kindSymbol) {
            case 'N':
                return <span style={{ color: 'green' }}>NEW</span>;
            case 'E':
                return <span>EDIT</span>;
            case 'D':
                return <span style={{ color: 'red' }}>DELETE</span>;
            default:
                return <span>{kindSymbol}</span>;
        }
    }

    render() {
        return (
            <tbody>
                {this.props.compareData.map(item => {
                    return (
                        <tr colSpan="3">
                            <td>{this.translateChangedItem(item.path)}</td>
                            <td>{JSON.stringify(item.kind === 'A' ? item.item.lhs : item.lhs)}</td>
                            <td>
                                <b>{JSON.stringify(item.kind === 'A' ? item.item.rhs : item.rhs)}</b>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        );
    }
}

ModalManageContentInfoRowDiffData.propTypes = {
    compareData: PropTypes.array
};

export default ModalManageContentInfoRowDiffData;



// WEBPACK FOOTER //
// ./src/components/modals/modalContent/ModalManageContentInfoRowDiffData.js